module.exports = __webpack_public_path__ + "img/delivery-method.1d94031f.png";